import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import Form from '../../../gd-form/form/form-modal-new/form-modal-new'
import FormError from '../../../gd-form/common/form-error/form-error'
import CustomFieldFormElement from '../../../gd-form/form-element/custom-field/custom-field-form-element'
import SessionCustomField from "../../../model2/custom-field/session-custom-field"
import FieldsFactory1 from "../../../fields/fields-factory"
import FieldFormElementView from "../../../fields3/render/form-elemnent-view"

type Props = {
    customFieldId   : ID

    onSubmit        : func
}

class ModalActionCustomField extends React.Component<Props> {

    private customField : SessionCustomField | null
    private form        : FormManager

    constructor(props: Props) {
        super(props)

        this.customField = gd.session.customFields.get(this.props.customFieldId)

        const initFormData = {
            value: this.customField?.defaultValue
        };

        const formStructure = {
            fields: {
                value: {
                    type: 'input',
                    label: this.customField?.name
                },
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result: any) => {
        this.props.onSubmit(result)
    }

    onField3ValueChange = (value: any) => {
        this.form.onFormComponentValueChange('value', value)
    }

    render() {
        if (!this.customField) {
            return null
        }

        let formComponent
        const field = FieldsFactory1.get(this.props.customFieldId)
        if (field.version === 3) {
            formComponent = (
                <FieldFormElementView
                    field     = {field}
                    model     = {{
                        [field.fieldId]: this.customField?.defaultValue
                    }}
                    onChange  = {this.onField3ValueChange}
                />
            )
        } else {
            formComponent = (
                <CustomFieldFormElement
                    form            = {this.form}
                    name            = "value"
                    customFieldId   = {this.customField?.id}
                    params          = {this.customField?.params ? this.customField.params : {}}
                />
            )
        }

        return (
            <Form
                form        = {this.form}
                submitLabel = "Submit"
            >
                <div className="tbl">
                    <div className="row">
                        <div className="label">
                            {this.customField?.name}
                        </div>
                        <div className="element">
                            {formComponent}
                            <FormError
                                form    = {this.form}
                                name    = "value"
                            />
                        </div>
                    </div>
                </div>
            </Form>
        )
    }
}

module.exports = ModalActionCustomField